module OnlineDPR.Application.Client.ControlPanel

open Browser.Dom
open Elmish
open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Client.Template
open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.Translations

type Msg =
| HideClicked of Notification*Link
| NotificationHidden of Notification
| PostedData of Result<Result<bool, string>, exn>

let postDataCmd link =
    Cmd.OfPromise.either(Http.postData link) "" (Ok >> PostedData) (Error >> PostedData)

let update msg (model:ControlPanelModel) =
    match msg with
    | HideClicked (n, l) -> match window.confirm CurrentTranslations.Translations.[TranslationKey.ControlPanel_Notifications_DprInput_Skip_Confirmation_Text] with
                            | true -> model, Cmd.batch [ postDataCmd l.Uri; Cmd.ofMsg (NotificationHidden n) ]
                            | false -> model, []
    | NotificationHidden n -> { model with Notifications = (model.Notifications |> List.filter (fun c -> c.Title <> n.Title)) }, []
    | PostedData _ -> model, []

let cardClass notification =
    match notification.State with
    | Todo -> "card card-warning"
    | Done -> "card card-success"

let cardLinks dispatch notification =
    seq { for link in notification.Links do
            yield (match link with
                   | Weblink l -> a [ Href l.Uri] [ str l.Text ]
                   | Hide l -> a [ Href "#"
                                   OnClick (fun _ -> HideClicked (notification, l) |> dispatch ) ]
                                 [ str l.Text ]) }

let createCard dispatch (notification:Notification) =
    div [ Class "col-xl-4" ]
        [ div [ Class (cardClass notification) ]
              [ div [ Class "card-header" ]
                  [ div [ Class "header-block" ]
                      [ p [ Class "title" ]
                          [ str notification.Title ] ] ]
                div [ Class "card-block" ]
                  [ p [ ]
                      [ str notification.Text ] ]
                div [ Class "card-footer" ]
                    [ List.ofSeq (cardLinks dispatch notification)
                      |> ofList ] ] ]

let rec notificationCards dispatch notifications =
    match notifications with
    | a::b::c::rest ->
        (div [ Class "row" ]
             [ yield createCard dispatch a
               yield createCard dispatch b
               yield createCard dispatch c ]) :: notificationCards dispatch rest
    | a::b::[] ->
        [ div [ Class "row" ]
               [ yield createCard dispatch a
                 yield createCard dispatch b ] ]
    | a::[] ->
        [ div [ Class "row" ]
               [ yield createCard dispatch a ] ]
    | [] -> []

let viewInTemplate model dispatch =
    article [ Class "content"]
            [ div [ Class "title-block" ]
                  [ h3 [ Class "title" ]
                      [ str (CurrentTranslations.Translations.[TranslationKey.ControlPanel_Title]) ]
                    p [ Class "title-description" ]
                      [ str (CurrentTranslations.Translations.[TranslationKey.ControlPanel_SubTitle]) ] ]
              section [ Class "section" ]
                      [ yield ofList (notificationCards dispatch model.Notifications) ]
            ]


let view (model:ControlPanelModel) dispatch =
    templateView model.Template [] [] (viewInTemplate model dispatch)
